import * as React from 'react';
import { NavLink } from 'react-router-dom';
import * as Glob from '../../Globale';
import * as Dati from '../../Dati';
import * as Data from '../../Data';
import * as DatiRCP from '../../DatiRCP';
import moment from 'moment';
import {
    ComparatoreProfessioneSingola,
    Trad,
    Tipo,
    ChiamaAPI,
    CampiPolizza,
    AccordionProdotti
} from '../';
import { CGaranzia } from '../../DatiRCP';
import { utc } from 'moment';
import { BasePureComponent } from '../BaseComponent';
import { type } from 'os';


interface IComparatoreStudioAssociatoProps extends Dati.IBaseProps {
    ID_Polizza: number;
    Frazionamento: number;
    AbilitaModifica: boolean;
    DatiPolizze: Glob.DatiJSON | DatiRCP.CComparatoreSingolo[];
    OnChangeGaranzia: (e: React.FormEvent<any> | string, valore?: any) => void;
    ID_TipoPolizzaStato: string;
    DatiPolizza: Glob.DatiJSON | DatiRCP.CComparatoreSingolo;
    ID_TipiProdotti: number[];
}

export class ComparatoreStudioAssociato extends BasePureComponent<IComparatoreStudioAssociatoProps> {
    private _DatiPolizze: DatiRCP.CComparatoreSingolo[] = [];
    private _DatiPolizza: DatiRCP.CComparatoreSingolo = new DatiRCP.CComparatoreSingolo();
    private _ElementoSelezionato: number = 0;
    private _CalcolaPreventivi: number = -1;
    private _Professioni: Dati.CTipo[] = [];

    public constructor(props: any) {
        super(props);
        this.PopolaDatiPolizze = this.PopolaDatiPolizze.bind(this);
        this.GeneraMenu = this.GeneraMenu.bind(this);
        this.OnClickMenu = this.OnClickMenu.bind(this);
        this.GeneraCorpo = this.GeneraCorpo.bind(this);
        this.OnChangeProdotto = this.OnChangeProdotto.bind(this);
        this.OnRisDatiProdotto = this.OnRisDatiProdotto.bind(this);
        this.OnInternalChange = this.OnInternalChange.bind(this);
        this.OnRisProdotto = this.OnRisProdotto.bind(this);
        this.PopolaProdotti = this.PopolaProdotti.bind(this);
        this.PreOnChangeGaranzia = this.PreOnChangeGaranzia.bind(this);
        this.PreOnChangePolizza = this.PreOnChangePolizza.bind(this);
        this.OnAggiungiAssicurato = this.OnAggiungiAssicurato.bind(this);
        this.OnRimuoviAssicurato = this.OnRimuoviAssicurato.bind(this);
        this.PolizzeJSONToPolizzeOBJ = this.PolizzeJSONToPolizzeOBJ.bind(this);
    }

    private GetValueFromString(o: any, s: any): any {
        try {
            s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
            s = s.replace(/^\./, '');           // strip a leading dot
            var a = s.split('.');
            for (var i = 0, n = a.length; i < n; ++i) {
                var k = a[i];
                if (k in o) {
                    o = o[k];
                } else {
                    return o;
                }
            }

            return o;
        }
        catch (e) {
            console.error("GetValueFromString", e, o, s);
        }
    }

    private SetValueFromString(o: any, s: any, v: any): any {
        try {
            s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
            s = s.replace(/^\./, '');           // strip a leading dot
            var a = s.split('.');

            switch (a.length) {
                case 1: {
                    o[a[0]] = v;
                    break;
                }
                case 2: {
                    o[a[0]][a[1]] = v;
                    break;
                }
                case 3: {
                    o[a[0]][a[1]][a[2]] = v;
                    break;
                }
                case 4: {
                    o[a[0]][a[1]][a[2]][a[3]] = v;
                    break;
                }
                case 5: {
                    o[a[0]][a[1]][a[2]][a[3]][a[4]] = v;
                    break;
                }
                case 6: {
                    o[a[0]][a[1]][a[2]][a[3]][a[4]][a[5]] = v;
                    break;
                }
                default: {
                    o = v;
                    break;
                }
            }
        }
        catch (e) {
            console.error("SetValueFromString", e, o, v);
        }
    }

    private OnInternalChange(e: React.FormEvent<any> | string, valore?: any): void {

        this._CalcolaPreventivi++;

        //console.warn("TEST", e, valore, this.props.Id, e.toString().substr(e.toString().length - 11, 11));

        if (typeof (e) == "string" && e.substr(e.length - 11, 11) == "PolizzeJSON") {
            this.PreOnChangePolizza(e, valore);
            //this.forceUpdate();
        } else {
            let index: string = "";

            if (typeof (e) == "string") {
                index = e.replace(this.props.Id, "_DatiPolizze");
            } else {
                index = e.currentTarget.name == "" ? e.currentTarget.id : e.currentTarget.name;
                index = index.replace(this.props.Id, "_DatiPolizze");
            }

            if (typeof (e) == "string") {
                //NULLA
            } else if ((e.currentTarget as HTMLInputElement).type == "checkbox") {
                valore = e.currentTarget.checked;
            } else if ((e.currentTarget as HTMLInputElement).type == "radio") {
                valore = e.currentTarget.value;
            } else if ((e.currentTarget as HTMLInputElement).type == "date") {
                if (e.currentTarget.value == "") {
                    valore = undefined;
                } else {
                    valore = new Date(moment(e.currentTarget.value, "YYYY-MM-DD").utc(true).valueOf());
                }
            } else {
                valore = e.currentTarget.value;
            }

            this.SetValueFromString(this, index, valore);
            this.props.OnChange(this.props.Id, JSON.stringify(this._DatiPolizze));
        }
    }

    private PopolaDatiPolizze() {

        //PRODOTTI ASSOCIATI INIZIO
        if (this.props.DatiPolizza != undefined && this.props.DatiPolizza.toString() != "") {
            if (typeof (this.props.DatiPolizza) == "string") {
                this._DatiPolizza = JSON.parse(this.props.DatiPolizza);
            } else {
                this._DatiPolizza = this.props.DatiPolizza;
            }
        }

        //let ProdottiAssociati: DatiRCP.CProdotto[] = [];
        //let ProdottiAssociatiTMP: DatiRCP.CProdotto[] = [];
        //if (typeof (this._DatiPolizza.PolizzeJSON) == "string" && this._DatiPolizza.PolizzeJSON != "") {
        //    ProdottiAssociatiTMP = JSON.parse(this._DatiPolizza.PolizzeJSON);
        //} else if (typeof (this._DatiPolizza.PolizzeJSON) != "string") {
        //    ProdottiAssociati = this._DatiPolizza.PolizzeJSON;
        //    let ProdottiAssociatiTMP: DatiRCP.CProdotto[] = this._DatiPolizza.PolizzeJSON;
        //}

        //for (let i: number = 0; i < ProdottiAssociatiTMP.length; i++)
        //    ProdottiAssociati.push(Glob.DeserializzaOggettoNuovo(DatiRCP.CProdotto, JSON.stringify(ProdottiAssociatiTMP)));

        //PRODOTTI ASSOCIATI FINE

        //PRODOTTI SINGOLI INIZIO
        if (typeof (this.props.DatiPolizze) == "string") {
            this._DatiPolizze = JSON.parse(this.props.DatiPolizze);
        } else {
            this._DatiPolizze = this.props.DatiPolizze;
        }

        while (this._DatiPolizze.length < 2) {
            this._DatiPolizze.push(new DatiRCP.CComparatoreSingolo());
        }

        //let totale: number[] = [];
        //for (let i: number = 0; i < this._DatiPolizze.length; i++) {
        //    let prodotti: DatiRCP.CProdotto[] = [];
        //    if (typeof (this._DatiPolizze[i].PolizzeJSON) == "string" && this._DatiPolizze[i].PolizzeJSON != "")
        //        prodotti = JSON.parse(this._DatiPolizze[i].PolizzeJSON);
        //    else
        //        prodotti = this._DatiPolizze[i].PolizzeJSON;


        //    for (let x: number = 0; x < prodotti.length; x++) {
        //        let prodotto: DatiRCP.CProdotto = new DatiRCP.CProdotto();
        //        prodotto = Glob.DeserializzaOggettoNuovo(DatiRCP.CProdotto, JSON.stringify(prodotti[x]));

        //        let index: number = ProdottiAssociati.findIndex(P => P.ID_BinderCompagnia == prodotto.ID_BinderCompagnia)

        //        if (index >= 0) {
        //            ProdottiAssociati[index].GaranziaBase.ImportoNetto += prodotto.GaranziaBase.ImportoNetto;
        //            ProdottiAssociati[index].GaranziaBase.ImportoLordo += prodotto.GaranziaBase.ImportoLordo;
        //        } else {
        //            prodotto.GaranziaBase.ID_TipoGaranzia = "RCPG-BaseStudioAssociato";
        //            prodotto.GaranziaBase.NomeClasseGaranzia = "RCPG-BaseStudioAssociato";
        //            prodotto.GaranzieAccessorie = [];
        //            ProdottiAssociati.push(prodotto);
        //        }

        //        //totale.push(prodotto.CalcolaImportoNettoTotale());
        //    }
        //}
        //PRODOTTI SINGOLI FINE

        //console.warn("ProdottiAssociati", ProdottiAssociati);
        //console.warn("Controllo", totale, this._DatiPolizze);
    }

    private GeneraMenu(datoPolizza: DatiRCP.CComparatoreSingolo, posizione: number): any {

        let Result: any = <a></a>;
        let DataKtwizardState: string = "pending";
        if (posizione == this._ElementoSelezionato)
            DataKtwizardState = "current";

        let Etichetta: string = "ND";

        let Icona: string = "flaticon-avatar"

        if (this._Professioni.find(p => p.ID_Chiave == datoPolizza.ID_TipoProdotto.toString()) != undefined) {
            let etichetta: Dati.CTipo | undefined = this._Professioni.find(p => p.ID_Chiave == datoPolizza.ID_TipoProdotto.toString());
            if (etichetta != undefined)
                Etichetta = Trad.Trad(etichetta.Valore);
        } else {
            if (posizione == this._DatiPolizze.length) {
                Etichetta = Trad.Trad("Totale");
                Icona = "flaticon-network";
            }
        }


        Result = <a key={"menu_" + posizione} className="kt-wizard-v2__nav-item" href="#" data-ktwizard-type="step" data-ktwizard-state={DataKtwizardState} onClick={(e) => { this.OnClickMenu(e, posizione) }}>
            <div className="kt-wizard-v2__nav-body">
                <div className="kt-wizard-v2__nav-icon">
                    <i className={Icona}></i>
                </div>
                <div className="kt-wizard-v2__nav-label">
                    <div className="kt-wizard-v2__nav-label-title">
                        {Etichetta}
                    </div>
                    <div className="kt-wizard-v2__nav-label-desc">
                        {Trad.Trad("AssicuratoNumero")} : {posizione + 1}
                    </div>
                </div>
            </div>
        </a>;
        return Result;
    }

    private OnRisProfessioni(sender: ChiamaAPI, professioni: Dati.CRisAPIListaTipo, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this._Professioni = professioni.Dati;
        }
        return false;
    }

    private OnChangeProdotto(posizione: number, valore: string) {
        this._DatiPolizze[posizione].ID_TipoProdotto = Number(valore);
        //console.warn("CONTROLLO", this.props.Name, JSON.stringify(this._DatiPolizze));
        this.props.OnChange(this.props.Name, JSON.stringify(this._DatiPolizze));
    }

    private GeneraCorpo(datoPolizza: DatiRCP.CComparatoreSingolo, posizione: number): any {
        let Result: any = <a></a>;
        let DataKtwizardState: string = "pending";
        if (posizione == this._ElementoSelezionato)
            DataKtwizardState = "current";

        Result = <div key={"corpo_" + posizione} className="kt-wizard-v2__content" data-ktwizard-type="step-content" data-ktwizard-state={DataKtwizardState}>
            <div className="kt-portlet__head StudioAssociatoNoBorder">
                <div className="kt-portlet__head-label">
                    <h3 className="kt-portlet__head-title">
                        {Trad.Trad("AssicuratoNumero")} : {posizione + 1}
                    </h3>
                </div>
                <div className="kt-portlet__head-toolbar StudioAssociatoNoBorder">
                    <ul className="nav nav-tabs nav-tabs-line nav-tabs-line-right StudioAssociatoNoBorder" role="tablist">
                        <li className="nav-item StudioAssociatoNoBorder">
                            <a className="nav-link StudioAssociatoNoBorder" data-toggle="tab" href="#kt_portlet_base_demo_1_tab_content" role="tab" onClick={(e) => { this.OnRimuoviAssicurato(e, posizione) }}>
                                <i className="flaticon-cancel"></i> {Trad.Trad("Rimuovi")}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="kt-form__section kt-form__section--first">
                <div className="kt-wizard-v2__form">
                    <div className="form-group">
                        <div className="form-group row">
                            <div className="col-12">
                                <label className="form-control-label">{Trad.Trad("Professione")}</label>
                                <Tipo Campo={this.props.Name + "[" + posizione + "].ID_TipoProdotto"}
                                    ID_ChiaveString={this._DatiPolizze[posizione].ID_TipoProdotto.toString()}
                                    OnAggiorna={(e, v) => {
                                        this.OnChangeProdotto(posizione, v)
                                    }}
                                    URL={"/api/Tipi/Tipo?tabella=TipiProdottiRCP&campo=TipoProdotto&parametri=" + this.props.ID_TipiProdotti.join(",")}
                                    Disabilitato={false}
                                    Ordinato={true} />
                            </div>
                        </div>
                        <CampiPolizza Gruppo="Livello1" Riga={1}
                            Info={datoPolizza.CampiPolizza}
                            DatoPolizza={datoPolizza.DatoRCPPolizza}
                            Identificatore={this.props.Name + "[" + posizione + "].DatoRCPPolizza"} Limiti={{}}
                            OnChange={(e, v) => {
                                this.OnChange(e, v);
                                //this.OnChangeGaranzia(e, undefined)
                            }} OnChangeDeroga={() => {
                            }} OnBlur={() => {
                            }} DimensioneGrafica={3} Abilitato={true} />

                        <ComparatoreProfessioneSingola
                            Id={this.props.Id + "[" + posizione + "].DatoRCPPolizza"}
                            Name={this.props.Name + "[" + posizione + "].DatoRCPPolizza"}
                            OnChange={this.OnInternalChange}
                            OnChangeGaranzia={this.PreOnChangeGaranzia}
                            ID_Polizza={this.props.ID_Polizza}
                            ID_TipoPolizzaStato={this.props.ID_TipoPolizzaStato}
                            AbilitaModifica={this.props.AbilitaModifica}
                            Frazionamento={this.props.Frazionamento}
                            DatiPolizza={datoPolizza}
                            ID_GaranzieJSON={this.props.Name + "[" + posizione + "]"}
                            ID_PolizzeJSON={this.props.Name + "[" + posizione + "]"}
                            ID_DatoRCPPolizza={this.props.Name + "[" + posizione + "]"}
                            DimensioneMinima={6}
                            ProductsHeaderVisible={true}
                            ProductsBodyVisible={false} />
                        <ChiamaAPI Aggiornare={this._DatiPolizze[posizione].ID_TipoProdotto} URL={"/api/polizza/GetInfoPolizza?ID_TipoProdotto=" + this._DatiPolizze[posizione].ID_TipoProdotto}
                            OnRis={(s, d, dn) => this.OnRisDatiProdotto(s, d, dn, posizione)}
                            OnErrore={this.OnErrore} Nome={this.props.Name + "[0]"} />
                        <ChiamaAPI Aggiornare={this._DatiPolizze[posizione].ID_TipoProdotto}
                            URL={"/api/Polizza/GetGaranzieRCP?ID_TipoProdotto=" + this._DatiPolizze[posizione].ID_TipoProdotto.toString()}
                            OnRis={(s, d, dn) => this.OnRisProdotto(s, d, dn, posizione)}
                            OnErrore={this.OnErrore} />
                        <ChiamaAPI Aggiornare={this._CalcolaPreventivi}
                            URL={"/api/Polizza/CalcolaPreventiviRCP"}
                            OnInvio={(s) => this.OnInvioCalcola(s, posizione)}
                            OnRis={(s, d, dn) => this.OnRisCalcolaPolizze(s, d, dn, posizione)}
                            OnErrore={this.OnErrore} />
                    </div>
                </div>
            </div>
        </div>;
        return Result;
    }

    private GeneraCorpoTotale(posizione: number): any {
        let Result: any = <a></a>;
        let DataKtwizardState: string = "pending";
        if (posizione == this._ElementoSelezionato)
            DataKtwizardState = "current";

        //console.warn("CONTROLLO", this._DatiPolizza, this._DatiPolizze);

        let DatiPolizzaTMP: DatiRCP.CComparatoreSingolo = new DatiRCP.CComparatoreSingolo();

        if (typeof (this.props.DatiPolizza) == "string")
            DatiPolizzaTMP = JSON.parse(this.props.DatiPolizza)
        else
            DatiPolizzaTMP = this.props.DatiPolizza

        //console.warn("DatiPolizzaTMP", DatiPolizzaTMP);

        Result = <div key={"corpo_" + posizione} className="kt-wizard-v2__content" data-ktwizard-type="step-content" data-ktwizard-state={DataKtwizardState}>
            <div className="kt-portlet__head StudioAssociatoNoBorder">
                <div className="kt-portlet__head-label">
                    <h3 className="kt-portlet__head-title">
                        {Trad.Trad("Totale")}
                    </h3>
                </div>
                <div className="kt-portlet__head-toolbar StudioAssociatoNoBorder">
                    <ul className="nav nav-tabs nav-tabs-line nav-tabs-line-right StudioAssociatoNoBorder" role="tablist">
                        <li className="nav-item StudioAssociatoNoBorder">
                            <a className="nav-link StudioAssociatoNoBorder" data-toggle="tab" href="#kt_portlet_base_demo_1_tab_content" role="tab" onClick={(e) => { this.OnRimuoviAssicurato(e, posizione) }}>
                                <i className="flaticon-cancel"></i> {Trad.Trad("Rimuovi")}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="kt-form__section kt-form__section--first">
                <div className="kt-wizard-v2__form">
                    <div className="form-group">
                        <div className="card">
                            <AccordionProdotti Id="PolizzeJSON" Name="PolizzeJSON"
                                OnChange={this.props.OnChange}
                                Value={DatiPolizzaTMP.PolizzeJSON}
                                Abilitato={this.props.AbilitaModifica}
                                CampoPreventivoSelezionato="PreventivoSelezionato"
                                Indice={2}
                                Forzabili={(this.props.ID_TipoPolizzaStato == Glob.Tipi_PS_ConsolidataSottoscrittore)}
                                DimensioneMinima={6}
                                ProductsHeaderVisible={false}
                                ProductsBodyVisible={true} />
                        </div>
                    </div>
                </div>
            </div>
        </div>;
        return Result;
    }


    private OnRisDatiProdotto(sender: ChiamaAPI, dati: DatiRCP.CRisAPIDatoTipiInfo_Comparatore, datiNuovi: boolean, posizione: number): React.ReactNode {
        if (datiNuovi) {
            let nuovaPolizza: any = Glob.CreaClassePolizzaRCP(dati.Info);
            this._DatiPolizze[posizione].DatoRCPPolizza = nuovaPolizza;
            this._DatiPolizze[posizione].CampiPolizza = dati.Info;

            //if (this._DatiPolizze[posizione].CampiPolizza["ID_AnagPolizza"] == undefined) {
            //    let CampoPolizza = new Dati.CInfoCampo();
            //    CampoPolizza.Campo = "ID_AnagPolizza";
            //    CampoPolizza.Etichetta = "AnagraficaAssicurato";
            //    CampoPolizza.Richiesto = true;
            //    CampoPolizza.Gruppo = "Livello3";
            //    CampoPolizza.SottoGruppo = "StudioAssociato";
            //    CampoPolizza.ID_TipoCampo = 14;
            //    CampoPolizza.ParametriJSON = "[{\"Campo\": \"AnnoInizioAttivita\",\"Etichetta\": \"AnnoInizioAttivita\",\"ID_TipoCampo\": 2,\"DimensioneGrafica\": 4}, {\"Campo\": \"NumeroIscrizione\",\"Etichetta\": \"NumeroIscrizione\",\"ID_TipoCampo\": 2,\"DimensioneGrafica\": 4}, {\"Campo\": \"AnnoIscrizioneAlbo\",\"Etichetta\": \"AnnoIscrizioneAlbo\",\"ID_TipoCampo\": 2,\"DimensioneGrafica\": 4}]";
            //    this._DatiPolizze[posizione].CampiPolizza["ID_AnagPolizza"] = CampoPolizza;
            //}

            this.props.OnChange(this.props.Name, JSON.stringify(this._DatiPolizze));
            //this.forceUpdate();
        }

        return false;
    }

    private OnRisProdotto(sender: ChiamaAPI, dati: DatiRCP.CRisAPIRCPInfo, datiNuovi: boolean, posizione: number): React.ReactNode {
        if (datiNuovi) {
            this._CalcolaPreventivi++;
            this.PopolaProdotti(dati, posizione, false);
        }

        return false;
    }

    private PopolaProdotti(dati: DatiRCP.CRisAPIRCPInfo, posizione: number, saveCastelletto?: boolean): void {
        let prodotti: DatiRCP.CProdotto[] = [];
        if (dati.Polizze != undefined) {

            for (let i: number = 0; i < dati.Polizze.length; i++) {//Selezaiono le polizze
                let prodotto: DatiRCP.CProdotto = new DatiRCP.CProdotto();
                prodotto.ID_Binder = dati.Polizze[i].Dati[0].ID_Binder;
                prodotto.ID_BinderCompagnia = dati.Polizze[i].Dati[0].ID_BinderCompagnia;
                prodotto.ID_AnagCompagniaBinder = dati.Polizze[i].Dati[0].ID_AnagCompagniaBinder;
                prodotto.Compagnia = dati.Polizze[i].Dati[0].Compagnia; //Garanzia base
                prodotto.Logo = "";
                prodotto.LimiteAccessori = dati.Polizze[i].Dati[0].LimiteAccessori;
                prodotto.LimiteFlessibilita = dati.Polizze[i].Dati[0].LimiteFlessibilita;
                prodotto.Scoperto = dati.Polizze[i].Dati[0].Scoperto;
                prodotto.ScopertoMin = dati.Polizze[i].Dati[0].ScopertoMin;
                prodotto.ScopertoMax = dati.Polizze[i].Dati[0].ScopertoMax;

                prodotto.PremioNettoMaggiorato = dati.Polizze[i].Dati[0].PremioNettoMaggiorato;
                prodotto.Accessori = dati.Polizze[i].Dati[0].Accessori;
                prodotto.Flessibilita = dati.Polizze[i].Dati[0].Flessibilita;

                let garanzia: DatiRCP.CGaranzia = new CGaranzia();
                garanzia.Abilitata = !dati.Polizze[i].Dati[0].Errore;
                if (dati.Polizze[i].Dati[0].Semaforo == DatiRCP.SemaforoRosso) {
                    garanzia.Abilitata = false;
                }
                garanzia.Semaforo = dati.Polizze[i].Dati[0].Semaforo;
                garanzia.Base = true;
                garanzia.ID_TipoGaranzia = dati.Polizze[i].Dati[0].ID_TipoGaranzia;
                garanzia.NomeClasseGaranzia = dati.Polizze[i].Dati[0].NomeClasseGaranzia;
                garanzia.ImportoLordo = dati.Polizze[i].Dati[0].ImportoLordo;
                garanzia.ImportoNetto = dati.Polizze[i].Dati[0].ImportoNetto;
                garanzia.Messaggio = dati.Polizze[i].Dati[0].Messaggio;
                garanzia.Dati = dati.Polizze[i].Dati[0].Dati;

                prodotto.GaranziaBase = garanzia;
                prodotto.GaranzieAccessorie = [];

                for (let x: number = 1; x < dati.Polizze[i].Dati.length; x++) {//Garanzie accessorie per questo parto da 1
                    let garanzia: DatiRCP.CGaranzia = new CGaranzia();
                    garanzia.Abilitata = !dati.Polizze[i].Dati[x].Errore;
                    if (dati.Polizze[i].Dati[x].Semaforo == DatiRCP.SemaforoRosso) {
                        garanzia.Abilitata = false;
                    }
                    garanzia.Semaforo = dati.Polizze[i].Dati[x].Semaforo;
                    garanzia.Base = false;
                    garanzia.ID_TipoGaranzia = dati.Polizze[i].Dati[x].ID_TipoGaranzia;
                    garanzia.NomeClasseGaranzia = dati.Polizze[i].Dati[x].NomeClasseGaranzia;
                    garanzia.ImportoLordo = dati.Polizze[i].Dati[x].ImportoLordo;
                    garanzia.ImportoNetto = dati.Polizze[i].Dati[x].ImportoNetto;
                    garanzia.Messaggio = dati.Polizze[i].Dati[x].Messaggio;
                    garanzia.Dati = dati.Polizze[i].Dati[x].Dati;
                    prodotto.GaranzieAccessorie.push(garanzia);
                }

                if (saveCastelletto) {
                    let tmpPolizze: DatiRCP.CProdotto[] = [];
                    if (typeof (this._DatiPolizze[posizione].PolizzeJSON) == "string") {
                        tmpPolizze = JSON.parse(this._DatiPolizze[posizione].PolizzeJSON);
                    } else {
                        tmpPolizze = this._DatiPolizze[posizione].PolizzeJSON;
                    }

                    let tmpPolizza: DatiRCP.CProdotto = new DatiRCP.CProdotto();
                    tmpPolizza = tmpPolizze[tmpPolizze.findIndex(p => p.ID_BinderCompagnia == dati.Polizze[i].Dati[0].ID_BinderCompagnia)];

                    if (typeof (tmpPolizza.CalcolaImportoNettoTotale) == "function" && tmpPolizza.PremioNettoMaggiorato != tmpPolizza.CalcolaImportoNettoTotale() && tmpPolizza.PremioNettoMaggiorato > prodotto.CalcolaImportoNettoTotale()) //Lo tengo solo se era stato impostato dall'utente
                        prodotto.PremioNettoMaggiorato = tmpPolizza.PremioNettoMaggiorato;

                    prodotto.Accessori = tmpPolizza.Accessori;
                    prodotto.Flessibilita = tmpPolizza.Flessibilita;
                    //prodotto.PremioNettoMaggiorato = tmpPolizza.PremioNettoMaggiorato;
                    prodotto.GaranziaBase.Selezionata = tmpPolizza.GaranziaBase.Selezionata;
                }

                prodotti.push(prodotto);
            }

            if (prodotti.length > 0) {
                if (this._DatiPolizze[posizione].GaranzieJSON == undefined || this._DatiPolizze[posizione].GaranzieJSON.toString() == "") {
                    this._DatiPolizze[posizione].GaranzieJSON = JSON.stringify(dati.Garanzie);
                } else {
                    if (typeof (this._DatiPolizze[posizione].GaranzieJSON) != "string")
                        this._DatiPolizze[posizione].GaranzieJSON = JSON.stringify(this._DatiPolizze[posizione].GaranzieJSON);
                }

                this._DatiPolizze[posizione].PolizzeJSON = JSON.stringify(prodotti);

                //if (this._DatiPolizze[posizione].PolizzeJSON == undefined || this._DatiPolizze[posizione].PolizzeJSON.toString() == "") {
                //    this._DatiPolizze[posizione].PolizzeJSON = JSON.stringify(dati.Polizze);
                //} else {
                //    if (typeof (this._DatiPolizze[posizione].PolizzeJSON) != "string")
                //        this._DatiPolizze[posizione].PolizzeJSON = JSON.stringify(this._DatiPolizze[posizione].PolizzeJSON);
                //}
                this.props.OnChange(this.props.Name, JSON.stringify(this._DatiPolizze));
            }
        }
    }

    private PreOnChangeGaranzia(e: React.FormEvent<any> | string, valore?: any): void {
        if (valore != undefined) {
            let index: string = "0";
            index = e.toString().replace("DatiAssociati[", "");
            index = index.replace("].GaranzieJSON", "");

            let DatiPolizze: any = JSON.parse(JSON.stringify(this._DatiPolizze));

            if (typeof (valore) == "string")
                DatiPolizze[Number(index)].GaranzieJSON = JSON.parse(valore);
            else
                DatiPolizze[Number(index)].GaranzieJSON = valore;

            this.props.OnChange(this.props.Name, JSON.stringify(DatiPolizze));
            this._CalcolaPreventivi++;
        }
    }

    private PreOnChangePolizza(e: React.FormEvent<any> | string, valore?: any): void {
        //console.warn("ENTRATO PreOnChangePolizza", e, valore);
        if (valore != undefined) {
            let index: string = "0";
            index = e.toString().replace("DatiAssociati[", "");
            index = index.replace("].PolizzeJSON", "");

            let DatiPolizze: any = JSON.parse(JSON.stringify(this._DatiPolizze));

            if (DatiPolizze[Number(index)] != undefined) {
                if (typeof (valore) == "string")
                    DatiPolizze[Number(index)].PolizzeJSON = JSON.parse(valore);
                else
                    DatiPolizze[Number(index)].PolizzeJSON = valore;

                //console.warn("DatiPolizze", DatiPolizze);
                this.props.OnChange(this.props.Name, JSON.stringify(DatiPolizze));
            }
        }
    }

    private OnInvioCalcola(sender: ChiamaAPI, posizione: number): any {
        let Polizze: DatiRCP.CRCPPolizze = new DatiRCP.CRCPPolizze();
        Polizze.Polizze = this.PolizzeJSONToPolizzeOBJ(posizione);
        //console.warn("CONTROLLO", Polizze);

        Polizze.Parametri = this._DatiPolizze[posizione].DatoRCPPolizza;
        if (typeof (this._DatiPolizze[posizione].DatoRCPPolizza) == "object")
            Polizze.Parametri["Frazionamento"] = this.props.Frazionamento;

        return Polizze;
    }

    private OnInvioCalcolaTutti(sender: ChiamaAPI): any {
        let Polizze: DatiRCP.CRCPPolizze[] = [];

        for (let i: number = 0; i < this._DatiPolizze.length; i++) {
            let polizze: DatiRCP.CRCPPolizze = new DatiRCP.CRCPPolizze();
            polizze.Polizze = this.PolizzeJSONToPolizzeOBJ(i);
            polizze.Parametri = this._DatiPolizze[i].DatoRCPPolizza;
            if (typeof (this._DatiPolizze[i].DatoRCPPolizza) == "object")
                polizze.Parametri["Frazionamento"] = this.props.Frazionamento;

            Polizze.push(polizze);
        }

        //console.warn("CONTROLLO", Polizze);

        return Polizze;
    }

    private PolizzeJSONToPolizzeOBJ(posizione: number): DatiRCP.CRCPPolizza[] {
        let Result: DatiRCP.CRCPPolizza[] = [];
        let garanzieApp: DatiRCP.CCampoGaranziaVisualizzazione[] = [];
        let polizzeApp: DatiRCP.CProdotto[] = [];

        if (this._DatiPolizze[posizione].PolizzeJSON.toString() != "") {
            if (typeof (this._DatiPolizze[posizione].PolizzeJSON) == "string")
                polizzeApp = JSON.parse(this._DatiPolizze[posizione].PolizzeJSON);
            else
                polizzeApp = this._DatiPolizze[posizione].PolizzeJSON;
        }

        if (this._DatiPolizze[posizione].GaranzieJSON.toString() != "") {
            if (typeof (this._DatiPolizze[posizione].GaranzieJSON) == "string")
                garanzieApp = JSON.parse(this._DatiPolizze[posizione].GaranzieJSON);
            else
                garanzieApp = this._DatiPolizze[posizione].GaranzieJSON;
        }

        for (let i: number = 0; i < polizzeApp.length; i++) {
            let polizzaApp: DatiRCP.CRCPPolizza = new DatiRCP.CRCPPolizza();
            polizzaApp.ID_Binder = polizzeApp[i].ID_Binder;
            polizzaApp.ID_BinderCompagnia = polizzeApp[i].ID_BinderCompagnia;
            polizzaApp.ID_AnagCompagniaBinder = polizzeApp[i].ID_AnagCompagniaBinder;
            polizzaApp.Compagnia = polizzeApp[i].Compagnia;
            polizzaApp.ImportoLordo = polizzeApp[i].GaranziaBase.ImportoLordo;
            polizzaApp.ImportoNetto = polizzeApp[i].GaranziaBase.ImportoNetto;
            polizzaApp.ID_TipoGaranzia = polizzeApp[i].GaranziaBase.ID_TipoGaranzia;
            polizzaApp.NomeClasseGaranzia = polizzeApp[i].GaranziaBase.NomeClasseGaranzia;

            polizzaApp.LimiteAccessori = polizzeApp[i].LimiteAccessori;
            polizzaApp.LimiteFlessibilita = polizzeApp[i].LimiteFlessibilita;

            polizzaApp.Scoperto = polizzeApp[i].Scoperto;
            polizzaApp.ScopertoMin = polizzeApp[i].ScopertoMin;
            polizzaApp.ScopertoMax = polizzeApp[i].ScopertoMax;

            for (let x: number = 0; x < garanzieApp.length; x++) {
                if (garanzieApp[x].Selezionata) {
                    let garanziaApp: DatiRCP.CRCPGaranzia = new DatiRCP.CRCPGaranzia();
                    garanziaApp.ID_TipoGaranzia = garanzieApp[x].ID_TipoGaranzia;
                    garanziaApp.NomeClasseGaranzia = garanzieApp[x].NomeClasseGaranzia[polizzaApp.Compagnia];

                    polizzaApp.Garanzie.push(garanziaApp);
                }
            }

            Result.push(polizzaApp);
        }
        return Result;
    }

    private OnRisCalcolaPolizze(sender: ChiamaAPI, dati: DatiRCP.CRisAPIRCPInfo, datiNuovi: boolean, posizione: number): React.ReactNode {
        if (datiNuovi && this._DatiPolizze[posizione] != undefined) {
            if (this._DatiPolizze[posizione].GaranzieJSON.toString() != "") {
                this.PopolaProdotti(dati, posizione, true);
            }
        }
        return false;
    }

    private OnClickMenu(e: React.FormEvent<any>, posizione: number): void {
        e.preventDefault();
        this._ElementoSelezionato = posizione;
        this.forceUpdate();
    }

    private OnAggiungiAssicurato(e: React.FormEvent<any>): void {
        e.preventDefault();
        this._DatiPolizze.push(new DatiRCP.CComparatoreSingolo());
        this._ElementoSelezionato = this._DatiPolizze.length - 1;
        this.props.OnChange(this.props.Id, JSON.stringify(this._DatiPolizze));
    }

    private OnRimuoviAssicurato(e: React.FormEvent<any>, posizione: number): void {
        e.preventDefault();
        this._DatiPolizze.splice(posizione, 1);
        if (this._ElementoSelezionato > 0)
            this._ElementoSelezionato = this._ElementoSelezionato - 1;

        this.props.OnChange(this.props.Id, JSON.stringify(this._DatiPolizze));
    }

    private Next(): void {
        if (this._ElementoSelezionato < this._DatiPolizze.length)
            this._ElementoSelezionato++;
        this.forceUpdate();
    }

    private Prev(): void {
        if (this._ElementoSelezionato > 0)
            this._ElementoSelezionato--;
        this.forceUpdate();
    }

    public render() {
        this.PopolaDatiPolizze();
        let menu: any[] = [];
        let corpo: any[] = [];
        for (let i: number = 0; i < this._DatiPolizze.length; i++) {
            menu.push(this.GeneraMenu(this._DatiPolizze[i], i));
            //console.warn("CONTROLLO", this._DatiPolizze[i]);
            corpo.push(this.GeneraCorpo(this._DatiPolizze[i], i));
        }

        menu.push(this.GeneraMenu(this._DatiPolizza, this._DatiPolizze.length));
        corpo.push(this.GeneraCorpoTotale(this._DatiPolizze.length));

        //console.warn("DATI", this._DatiPolizza.PolizzeJSON);

        return <div className="card">
            <div className="kt-grid  kt-wizard-v2 kt-wizard-v2--white" id="kt_wizard_v2" data-ktwizard-state="first">
                <div className="kt-grid__item kt-wizard-v2__aside">
                    <div className="kt-wizard-v2__nav">
                        <div className="kt-wizard-v2__nav-items">
                            <a key={"menu_A"} className="kt-wizard-v2__nav-item" href="#" data-ktwizard-type="step" data-ktwizard-state="pending" onClick={(e) => { this.OnAggiungiAssicurato(e) }}>
                                <div className="kt-wizard-v2__nav-body">
                                    <div className="kt-wizard-v2__nav-icon">
                                        <i className="flaticon-plus"></i>
                                    </div>
                                    <div className="kt-wizard-v2__nav-label">
                                        <div className="kt-wizard-v2__nav-label-title">
                                            {Trad.Trad("Aggiungi")}
                                        </div>
                                        <div className="kt-wizard-v2__nav-label-desc">

                                        </div>
                                    </div>
                                </div>
                            </a>
                            {menu}
                        </div>
                    </div>
                </div>
                <div className="kt-grid__item kt-grid__item--fluid kt-wizard-v2__wrapper">
                    <div className="kt-portlet__body" id="kt_form">
                        {corpo}
                        <div className="kt-form__actions">
                            <div className={this._ElementoSelezionato == 0 ? "btn " + Glob.DimensioneCSS(2) : "btn btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u " + Glob.DimensioneCSS(2)} data-ktwizard-type="action-next">
                                <span className={this._ElementoSelezionato == 0 ? "hidden" : ""} onClick={() => this.Prev()}>
                                    {Trad.Trad("Precedente")}
                                </span>
                            </div>
                            <div className={"btn " + Glob.DimensioneCSS(8)}></div>
                            <div className={this._ElementoSelezionato == this._DatiPolizze.length ? "btn " + Glob.DimensioneCSS(2) : "btn btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u " + Glob.DimensioneCSS(2)} data-ktwizard-type="action-next">
                                <span className={this._ElementoSelezionato == this._DatiPolizze.length ? "hidden" : ""} onClick={() => this.Next()}>
                                    {Trad.Trad("Successivo")}
                                </span>
                            </div>
                        </div>
                        <ChiamaAPI Aggiornare={1}
                            URL={"/api/Tipi/Tipo?tabella=TipiProdottiRCP&campo=TipoProdotto&parametri=X"}
                            OnRis={(s, d, dn) => this.OnRisProfessioni(s, d, dn)}
                            OnErrore={this.OnErrore} />
                    </div>
                </div>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/RCP/ComparatoreStudioAssociato.tsx